import { Component, OnInit } from '@angular/core';
import { Language } from '../../../config/model/app-config.model';
import { LanguageService } from '../../../shared/service/language.service';

@Component({
    selector: 'language',
    templateUrl: './language.component.html',
    styleUrls: ['language.component.scss'],
    standalone: false
})
export class LanguageComponent implements OnInit {
  public languageList: Language[];
  public dropDownLabel: string;

  constructor(private _languageService: LanguageService) {
    this.languageList = this._languageService.languageList;
  }

  ngOnInit() {
    this.dropDownLabel = this._languageService.selectedLanguage.label;
  }

  /**
   * @function changeLanguage
   * @param {Language} inputLang
   * @description Set selected language
   */
  public changeLanguage(inputLang: Language) {
    // do nothing if language already selected
    if (this._languageService.selectedLanguage === inputLang) {
      return;
    }
    // set language and selected dropdown label
    this._languageService.changeLanguage(inputLang);
    this.dropDownLabel = inputLang.label;
  }
}
